import { DateTime } from "luxon";

export const getDateRangeLabel = ({ startDate, endDate }: { startDate?: string | null; endDate?: string | null }) => {
  const startDateTime = startDate ? DateTime.fromISO(startDate) : null;
  const endDateTime = endDate ? DateTime.fromISO(endDate) : null;

  let label = "";

  if (startDateTime?.isValid) {
    label += startDateTime.toFormat("LLL dd");
  }

  if (!endDateTime?.isValid) {
    // No Endtime should only show starttime
    return label;
  }

  if (
    startDateTime?.year === endDateTime.year &&
    startDateTime?.month === endDateTime.month &&
    startDateTime?.day === endDateTime.day
  ) {
    // Same day
    return label;
  }

  if (startDateTime?.year === endDateTime.year && startDateTime?.month === endDateTime.month) {
    // Same month
    label += ` - ${endDateTime.toFormat("dd")}`;
  } else {
    // Different month
    label += ` - ${endDateTime.toFormat("LLL dd")}`;
  }

  return label;
};
